/** @jsxImportSource @emotion/react */
import { css, useTheme } from '@emotion/react';
import section4 from 'static/main/section4.png';

const Section4 = () => {
  const { mq } = useTheme();

  const section4Style = css`
    .container {
      max-width: 1535px;
      padding: 140px 40px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      h2 {
        font-size: 56px;
        font-weight: 600;
        line-height: 76px;
      }
      .text {
        line-height: 28px;
        font-size: 18px;
      }
      img {
        width: 800px;
      }
    }
    ${mq.mobile} {
      .container {
        flex-direction: column;
        padding: 0;

        .right {
          padding: 35px 32px 83px 32px;
          width: 100%;
          h2 {
            font-size: 28px;
            font-weight: 700;
            line-height: 36px;
          }
          .text {
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            margin-top: 4px;
          }
        }
        img {
          width: 100%;
        }
      }
    }
  `;
  return (
    <div css={section4Style}>
      <div className="container">
        <div className="left">
          <img src={section4} alt="section3" />
        </div>
        <div className="right">
          <h2>
            한눈에 보는
            <br />
            현황
          </h2>
          <div className="text">
            내 쇼핑몰을 구독한 회원, 일별 주문 내역 등의 현황을 보고
            <br />
            매월 나에게 돌아온 수익금을 확인해보세요
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section4;
